module.exports = __webpack_public_path__ + "static/img/04-federal bank - epay portal.170b8b84.jpg";